export class ExternTierarzt {
    extern_tierarzt_id: number;
    name: string;
    email: string;
    telefon: string;
    fax: string;
    strasse: string;
    plz: string;
    ort: string;
}
